export const KEYWORDS: any[] = [
  {name: 'Basemap', value: 'Basemap', selected: false},
  {name: 'Borders', value: 'Borders', selected: false},
  {name: 'Physical geography', value: 'Physical geography', selected: false},
  {name: 'Demographics', value: 'Demographics', selected: false},
  {name: 'Economics', value: 'Economics', selected: false},
  {
    name: 'Socio political conditions',
    value: 'Socio political conditions',
    selected: false,
  },
  {name: 'Culture', value: 'Culture', selected: false},
  {name: 'Transport', value: 'Transport', selected: false},
  {name: 'Land use', value: 'Land use', selected: false},
  {name: 'Environment', value: 'Environment', selected: false},
  {name: 'Water', value: 'Water', selected: false},
  {name: 'Hazards', value: 'Hazards', selected: false},
  {name: 'Cadastre', value: 'Cadastre', selected: false},
  {name: 'Infrastructure', value: 'Infrastructure', selected: false},
  {name: 'Real estate', value: 'Real estate', selected: false},
  {name: 'Planning', value: 'Planning', selected: false},
  {name: 'Complex information', value: 'Complex information', selected: false},
];
export const INSPIRETHEMES: any[] = [
  {
    name: 'Addresses',
    value: 'http://inspire.ec.europa.eu/theme/ad',
    selected: false,
  },
  {
    name: 'Administrative units',
    value: 'http://inspire.ec.europa.eu/theme/au',
    selected: false,
  },
  {
    name: 'Coordinate reference systems',
    value: 'http://inspire.ec.europa.eu/theme/rs',
    selected: false,
  },
  {
    name: 'Geographical grid systems',
    value: 'http://inspire.ec.europa.eu/theme/gg',
    selected: false,
  },
  {
    name: 'Cadastral parcels',
    value: 'http://inspire.ec.europa.eu/theme/cp',
    selected: false,
  },
  {
    name: 'Geographical names',
    value: 'http://inspire.ec.europa.eu/theme/gn',
    selected: false,
  },
  {
    name: 'Hydrography',
    value: 'http://inspire.ec.europa.eu/theme/hy',
    selected: false,
  },
  {
    name: 'Protected sites',
    value: 'http://inspire.ec.europa.eu/theme/ps',
    selected: false,
  },
  {
    name: 'Transport networks',
    value: 'http://inspire.ec.europa.eu/theme/tn',
    selected: false,
  },
  {
    name: 'Elevation',
    value: 'http://inspire.ec.europa.eu/theme/el',
    selected: false,
  },
  {
    name: 'Geology',
    value: 'http://inspire.ec.europa.eu/theme/ge',
    selected: false,
  },
  {
    name: 'Land cover',
    value: 'http://inspire.ec.europa.eu/theme/lc',
    selected: false,
  },
  {
    name: 'Orthoimagery',
    value: 'http://inspire.ec.europa.eu/theme/oi',
    selected: false,
  },
  {
    name: 'Agricultural and aquaculture facilities',
    value: 'http://inspire.ec.europa.eu/theme/af',
    selected: false,
  },
  {
    name: 'Area management/restriction/regulation zones and reporting units',
    value: 'http://inspire.ec.europa.eu/theme/am',
    selected: false,
  },
  {
    name: 'Atmospheric conditions',
    value: 'http://inspire.ec.europa.eu/theme/ac',
    selected: false,
  },
  {
    name: 'Bio-geographical regions',
    value: 'http://inspire.ec.europa.eu/theme/br',
    selected: false,
  },
  {
    name: 'Buildings',
    value: 'http://inspire.ec.europa.eu/theme/bu',
    selected: false,
  },
  {
    name: 'Energy resources',
    value: 'http://inspire.ec.europa.eu/theme/er',
    selected: false,
  },
  {
    name: 'Environmental monitoring facilities',
    value: 'http://inspire.ec.europa.eu/theme/ef',
    selected: false,
  },
  {
    name: 'Habitants and biotopes',
    value: 'http://inspire.ec.europa.eu/theme/hb',
    selected: false,
  },
  {
    name: 'Human health and safety',
    value: 'http://inspire.ec.europa.eu/theme/hh',
    selected: false,
  },
  {
    name: 'Land use',
    value: 'http://inspire.ec.europa.eu/theme/lu',
    selected: false,
  },
  {
    name: 'Mineral resources',
    value: 'http://inspire.ec.europa.eu/theme/mr',
    selected: false,
  },
  {
    name: 'Natural risk zones',
    value: 'http://inspire.ec.europa.eu/theme/nz',
    selected: false,
  },
  {
    name: 'Oceanographic geographical features',
    value: 'http://inspire.ec.europa.eu/theme/of',
    selected: false,
  },
  {
    name: 'Population distribution - demography',
    value: 'http://inspire.ec.europa.eu/theme/pd',
    selected: false,
  },
  {
    name: 'Production and industrial facilities',
    value: 'http://inspire.ec.europa.eu/theme/pf',
    selected: false,
  },
  {
    name: 'Sea regions',
    value: 'http://inspire.ec.europa.eu/theme/sr',
    selected: false,
  },
  {
    name: 'Soil',
    value: 'http://inspire.ec.europa.eu/theme/so',
    selected: false,
  },
  {
    name: 'Species distribution',
    value: 'http://inspire.ec.europa.eu/theme/sd',
    selected: false,
  },
  {
    name: 'Statistical units',
    value: 'http://inspire.ec.europa.eu/theme/su',
    selected: false,
  },
  {
    name: 'Utility and governmental services',
    value: 'http://inspire.ec.europa.eu/theme/us',
    selected: false,
  },
  {
    name: 'Meteorological geographical features',
    value: 'http://inspire.ec.europa.eu/theme/mf',
    selected: false,
  },
  {
    name: 'Atmospheric Conditions and meteorological geographical features',
    value: 'http://inspire.ec.europa.eu/theme/ac-mf',
    selected: false,
  },
];
export const SORTBYVALUES: any[] = [
  {name: 'None', value: 'None'},
  {name: 'Title', value: 'title'},
  {name: 'Date', value: 'date:D'},
  {name: 'Bbox', value: 'bbox'},
];
export const TYPES: any[] = [
  {name: 'None', value: 'None'},
  {name: 'Datasource', value: 'datasource'},
  {name: 'Service', value: 'service'},
  {name: 'Application', value: 'application'},
  {name: 'Feature catalogue', value: 'feature catalogue'},
];
